export var BRAND_COLORS = {
  blue: 'blue.40',
  brown: 'brown.30',
  gray: 'gray.70',
  green: 'green.30',
  orange: 'orange.50',
  pink: 'pink.40',
  yellow: 'yellow.40'
};